import { render, staticRenderFns } from "./LastTicketsActions.vue?vue&type=template&id=d932e4ae&scoped=true"
import script from "./LastTicketsActions.vue?vue&type=script&lang=js"
export * from "./LastTicketsActions.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsActions.vue?vue&type=style&index=0&id=d932e4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d932e4ae",
  null
  
)

export default component.exports